import {
  PolfEventModeEnum,
  PolfEventRankingEnum,
} from '@polf/shared/codegen/types'

/**
 * Norwegian short label for the eyebrow / topbar — uppercase by CSS.
 * Returned verbatim (no extra letterSpacing) so callers compose freely.
 */
export const modeEyebrow = (
  mode: PolfEventModeEnum | null | undefined
): string => {
  switch (mode) {
    case PolfEventModeEnum.Polf:
      return 'POLF'
    case PolfEventModeEnum.Golf:
      return 'Golf'
    case PolfEventModeEnum.Scramble:
      return 'Scramble'
    case PolfEventModeEnum.Bestball:
      return 'Best ball'
    default:
      return 'POLF'
  }
}

/** POLF mode is the only one with the chip economy attached. */
export const usesChips = (
  mode: PolfEventModeEnum | null | undefined
): boolean => mode === PolfEventModeEnum.Polf

/** Did the event opt into net-stroke ranking? */
export const isNetStrokes = (
  ranking: PolfEventRankingEnum | null | undefined
): boolean => ranking === PolfEventRankingEnum.NetStrokes
